// Whether real Auth0 config is present. False in local dev before a
// capability-registry Auth0 application exists (see .env.example) — the app then runs
// unauthenticated, the same "no identity-aware host" fallback the backend already
// documents for CAPAGENT_TRUST_CLIENT_IDENTITY. Never expected to be false in a real
// deployment, where these three env vars are always set (see ../.github or the SAM
// template's frontend deploy step, once one exists).
export const AUTH0_DOMAIN = import.meta.env.VITE_AUTH0_DOMAIN;
export const AUTH0_CLIENT_ID = import.meta.env.VITE_AUTH0_CLIENT_ID;
export const AUTH0_AUDIENCE = import.meta.env.VITE_AUTH0_AUDIENCE;

/** Optional — when unset, Auth0 falls back to its generic Home Realm Discovery
 * ("where do you work") screen, which only lists connections under their
 * human-readable display names (not the connection name itself), making a specific
 * one hard to find/guess. Setting this skips that screen and goes straight to the
 * named connection. E.g. "test-idp-internal" for testing without real Okta access,
 * "GuildOkta-internal" for real employee SSO. */
export const AUTH0_CONNECTION = import.meta.env.VITE_AUTH0_CONNECTION as string | undefined;

/** The one switch the rest of src/auth/ branches on: all three Auth0 values present means
 * real login; anything missing means the unauthenticated local-dev mode described above. */
export const AUTH_ENABLED = Boolean(AUTH0_DOMAIN && AUTH0_CLIENT_ID && AUTH0_AUDIENCE);
